import { render, staticRenderFns } from "./sixSlider.vue?vue&type=template&id=0eb0cbd2&scoped=true&"
import script from "./sixSlider.vue?vue&type=script&lang=js&"
export * from "./sixSlider.vue?vue&type=script&lang=js&"
import style0 from "./sixSlider.vue?vue&type=style&index=0&id=0eb0cbd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb0cbd2",
  null
  
)

export default component.exports